import React from 'react';
import LoadingImage from '../assets/loader_wild.png';

export const Loading = (props) => {
    return <div className={`loading ${props.fadeOut ? 'fade-out' : ''}`}><img src={LoadingImage} alt="Laden..."/></div>
}
